import Transaction from '../components/uiComponents/Toasts/Transaction';
import { sendTXConfirmationToDevices, TXDescriptionEnum, TXNamesEnum } from './backendHelpers';
import { toast } from 'react-toastify';
import { BigNumber, ethers } from 'ethers';
import React, { useEffect, useState } from "react";

import { createProvider, Eip1193, networkToChainId } from "../constants/EIP1193";
import { GLIP_BACKEND_TOKEN_INFO_STORAGE_KEY } from "../constants/storage_constats";

import { abi as ERC20_ABI } from '../contract_abis/erc20_rw';
import { ERC721 } from '../contract_abis/ERC721';
import { ERC1155 } from '../contract_abis/ERC1155';

enum TokenTypes {
    ERC20 = 'ERC20',
    ERC721 = 'ERC721',
    ERC1155 = 'ERC1155',
    ERC721_LAZY = 'ERC721_LAZY',
    ERC1155_LAZY = 'ERC1155_LAZY',
    ETH = 'ETH',
}


export const sendTransferConfirmationToDevices = (txHash: string, tokenType:TokenTypes, txImage: string = "", chainId:any) => {
    switch (tokenType) {
        case TokenTypes.ETH:
            sendTXConfirmationToDevices(TXNamesEnum.NativeTransfer, TXDescriptionEnum.NativeTransfer, chainId, txHash, txImage);
            break;
        case TokenTypes.ERC20:
            sendTXConfirmationToDevices(TXNamesEnum.ERC20Transfer, TXDescriptionEnum.ERC20Transfer, chainId, txHash, txImage);
            break;
        case TokenTypes.ERC721:
            sendTXConfirmationToDevices(TXNamesEnum.ERC721Transfer, TXDescriptionEnum.ERC721Transfer, chainId, txHash, txImage);
            break;
        case TokenTypes.ERC1155:
            sendTXConfirmationToDevices(TXNamesEnum.ERC1155Transfer, TXDescriptionEnum.ERC1155Transfer, chainId, txHash, txImage);
            break;
        default:
            break;
    }
}

const checkBalanceForGas = async () => {
    const userData: any = JSON.parse(localStorage.getItem(GLIP_BACKEND_TOKEN_INFO_STORAGE_KEY) || '{}');
    const publicAddress: string = userData.id;
    return false;
}


async function sendingTx({provider, toastId, token, tx}:any){
    let txHash: any;
    txHash = await provider.send("eth_sendTransaction", [tx]);
    toast.update(toastId.current, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1000,
        theme: 'dark',
        closeButton: false,
        render: () => <Transaction type='success'/>, 
        type: toast.TYPE.SUCCESS,
    });
    
    provider.provider.waitForTransaction(txHash, 3, 300000).then((tx: any) => {
        //send notification of success transaction          
        if(tx.status === 1) {
            //@ts-ignore
            toast.update(toastId.current, {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1000,
                theme: 'dark',
                closeButton: false,
                render: () => <Transaction type='success'/>, 
                type: toast.TYPE.SUCCESS,
                // onClose: () => props.refreshPage(),
            });
            sendTransferConfirmationToDevices(txHash, token.type, token.imageUri, networkToChainId.get(token.chain));
        }
        else {
            //@ts-ignore
            toast.update(toastId.current, {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1000,
                theme: 'dark',
                closeButton: false,
                render: () => <Transaction type='failure'/>,
                type: toast.TYPE.ERROR,  
            });
        }      
        
    }).catch((err: any) => {
        //send notification of failed transaction
        //@ts-ignore
        toast.update(toastId.current, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1000,
            theme: 'dark',
            closeButton: false,
            render: () => <Transaction type='failure'/>,
            type: toast.TYPE.ERROR,  
        });
    });
    return txHash;
}

export async function initiateTransfer({
    setTransferActive, setTransferText,
    goBack, amount,
    token, toastId, address}:any){
    setTransferActive(false);
    setTransferText('Transferring...');
    toast.dismiss();
    //@ts-ignore
    toastId.current = toast(<Transaction type={'pending'}/>, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        theme: 'dark',
        icon: false,
        closeButton: false,            
    });
    // go back to home page
    //  navigate(-1);
    goBack();
    console.log('legend', token);
    let signer;
    let provider;
    let tx: ethers.providers.TransactionRequest;
    try {
        const re: any = createProvider(token.chain);
        signer = re['signer']
        provider = re['provider']
        console.log('legend', signer, provider, re);
        // check balance here before transaction
        //await checkBalanceForGas();
        
        
        const ethersAmount: ethers.BigNumber = (amount) ? ethers.utils.parseUnits(amount, token.decimals) : ethers.BigNumber.from(0);
        
        const toAddress = ethers.utils.getAddress(address);
        
        
        if (token.type === TokenTypes.ETH) {
            console.log("Poptx ETH");
            tx  = {
                to: toAddress,
                from: await signer.getAddress(),
                value: BigNumber.from(ethersAmount),
                // chainId: await signer.getChainId(),
            }
        }
        else if (token.type === TokenTypes.ERC20) {
            console.log("Poptx ERC20");
            const contract = new ethers.Contract(token.contractAddress, ERC20_ABI, provider);
            tx = await contract.populateTransaction.transfer(toAddress, BigNumber.from(ethersAmount));
        } else if (token.type === TokenTypes.ERC721) {
            console.log(
                "Poptx ERC721",
                token.contractAddress,
                token.tokenId
            );
            const contract = new ethers.Contract(token.contractAddress, ERC721.abi, provider);
            tx = await contract.populateTransaction["safeTransferFrom(address,address,uint256)"](await signer.getAddress(), toAddress, token.tokenId);
        } else if (token.type === TokenTypes.ERC1155) {
            console.log("Poptx ERC1155");
            const contract = new ethers.Contract(token.contractAddress, ERC1155.abi, provider);
            tx = await contract.populateTransaction["safeTransferFrom(address,address,uint256,uint256,bytes)"](await signer.getAddress(), toAddress, token.tokenId, ethersAmount.toString(), '0x');
        } else throw new Error("Token type not supported for transfer");

    } catch (e) {
        console.log(e);
        toast.dismiss();
        toast.error(<Transaction type='failure' />, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 2000,
            theme: 'dark',
            closeButton: false,
        });
        return;
    }

    console.log("tx made");
    
    // Send transaction using signer
    try{
        await sendingTx({provider, toastId, token, tx});
    }
    catch(e){
        toast.dismiss();
        toast.error(<Transaction type='failure' />, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 2000,
            theme: 'dark',
            closeButton: false,
        });
    }
}  


//Add logic to check if user has enough balance to transfer
export const checkBalance = (token:any, amount:any) => {
    console.log(token.quantity, token);
    if (token.type === TokenTypes.ETH) {
        if (parseFloat(token.quantity) < parseFloat(amount)) {
            return false;
        }
    }
    if (token.type === TokenTypes.ERC20) {
        if (parseFloat(token.quantity) < parseFloat(amount)) {
            return false;
        }
    }
    if (token.type === TokenTypes.ERC721) {
        if (parseFloat(token.quantity) < 1) {
            return false;
        }
    }
    if (token.type === TokenTypes.ERC1155) {
        if (parseFloat(token.quantity) < parseFloat(amount)) {
            return false;
        }
    }
    return true;
}


export async function getPrice(token:any, CoinGeckoClient:any){
    console.log(token)
    // console.log(token.currency.coingeckoId, '=================== coingeckoId');
    // console.log(token.type, '=================== token type');
    if (token.type === TokenTypes.ERC20 || token.type === TokenTypes.ETH) {
        let data: any = await CoinGeckoClient.simple.price({
            ids: [token.currency.coingeckoId]
        });
        return data;
    } else {
        return null;
    }    
};
